export default class Public {
  static defaultImg =
    'http://chenglianyijia.oss-cn-beijing.aliyuncs.com/manager/addImg.svg'
  static status = {
    delete: '5', // 删除
    draft: '0', // 草稿
    warehouse: '1', // 仓库中
    advance: '2', // 预售中
    sale: '3', // 在售中
    all: ['1', '2', '3']
  };// 商品列表状态
  static role ={
    area: '3', // 区
    city: '4', // 市
    province: '5' // 省
}; // 代理商身份

static role ={
    area: '3', // 区
    city: '4', // 市
    province: '5' // 省
}; // 代理商身份
}
